import { applyHtmlSpecialChars } from "../util/";
import { OptionsParagraph } from "./paragraph";
import { Relationship } from "./relationship";
import { CreateText, OptionsText } from "./text";

interface OptionsLink extends OptionsText {
    /** Color: HEX value. Default as 0563C1 */
    color?: string;
    /** Link: URL or #bookmark_name */
    link: string;
    /** Character style. Default as Hyperlink */
    rStyle?: string;
    /** Underline. Default as single */
    underline?:
        | "single"
        | "words"
        | "double"
        | "thic"
        | "dotted"
        | "dottedHeavy"
        | "dash"
        | "dashedHeavy"
        | "dashLong"
        | "dashLongHeavy"
        | "dotDash"
        | "dashDotHeavy"
        | "dotDotDash"
        | "dashDotDotHeavy"
        | "wave"
        | "wavyHeavy"
        | "wavyDouble"
        | "none";
}

/**
 * Create hyperlink
 */
class CreateLink extends CreateText {
    /**
     * Id
     */
    protected id: string;

    /**
     * Element options
     */
    protected options: OptionsLink;

    /**
     * Constructor
     *
     * @param options - Options link
     * @param optionsParagraph - Options paragraph
     * @param id - Id
     */
    constructor(
        options: OptionsLink,
        optionsParagraph: OptionsParagraph = {},
        id: string
    ) {
        super(options, optionsParagraph);

        // default options
        options.color ??= "0563C1";
        options.rStyle ??= "Hyperlink";
        options.underline ??= "single";

        this.options = options;
        this.id = id;
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        let contents = super.create();

        if (this.options.link.startsWith("#")) {
            // bookmark, remove # before adding it
            contents =
                '<w:hyperlink w:anchor="' +
                applyHtmlSpecialChars(this.options.link.slice(1)) +
                '" w:history="1">' +
                contents +
                "</w:hyperlink>";
        } else {
            // hyperlink
            contents =
                '<w:hyperlink r:id="' +
                this.id +
                '" w:history="1">' +
                contents +
                "</w:hyperlink>";

            // add external relationship
            const newExternalRelationship: Relationship = {
                id: this.id,
                target: applyHtmlSpecialChars(this.options.link),
                targetMode: "External",
                type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
            };
            this.externalRelationships.push(newExternalRelationship);
        }

        return contents;
    }
}

export { CreateLink, OptionsLink };
